import React, { Fragment } from 'react'
import { TAB_RECENT, TAB_LEADER_BOARD, TAB_STORIES } from 'app/constants/feed'
import FeedHeader from './FeedHeader'
import FeedFilter from './FeedFilter'
import FeedRecent from './FeedRecentList'
import FeedLeaderBoardList from './FeedLeaderBoardList'
import './styles.scss'
import FeedStoriesList from './FeedStoriesList/index'

const bs = 'feed'

const Feed = ({ tab }) => {
  return (
    <div className={bs}>
      <FeedHeader />
      {tab === TAB_RECENT && <FeedRecent />}
      {tab === TAB_LEADER_BOARD && (
        <Fragment>
          <FeedFilter />
          <FeedLeaderBoardList />
        </Fragment>
      )}
      {tab === TAB_STORIES && (
        <Fragment>
          <FeedStoriesList />
        </Fragment>
      )}
    </div>
  )
}

export default Feed
